import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import {
  UnsavedChangesAction,
  UnsavedChangesOptions,
  UnsavedChangesService
} from '../../services/unsaved-changes.service';

@Component({
  selector: 'app-unsaved-changes-modal',
  templateUrl: './unsaved-changes-modal.component.html',
  styleUrls: ['./unsaved-changes-modal.component.css']
})
export class UnsavedChangesModalComponent implements OnInit, OnDestroy {
  isOpen = false;
  options: UnsavedChangesOptions | null = null;
  private currentResult: Subject<UnsavedChangesAction> | null = null;
  private destroy$ = new Subject<void>();

  constructor(private unsavedChangesService: UnsavedChangesService) {}

  ngOnInit(): void {
    this.unsavedChangesService.request$
      .pipe(takeUntil(this.destroy$))
      .subscribe(({ options, result }) => {
        this.options = options;
        this.currentResult = result;
        this.isOpen = true;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onStay(): void {
    this.emitAndClose('stay');
  }

  onDiscard(): void {
    this.emitAndClose('discard');
  }

  onSave(): void {
    this.emitAndClose('save');
  }

  onClose(): void {
    this.onStay();
  }

  private emitAndClose(action: UnsavedChangesAction): void {
    if (this.currentResult) {
      this.currentResult.next(action);
      this.currentResult.complete();
    }
    this.isOpen = false;
    this.options = null;
    this.currentResult = null;
  }
}
